var path = '/pages/guestlists/views/pages/rsvps/changelog.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<al-entity-change-log entity=\"'rsvp'\"\n                      ng-if=\"!vm.loading\"\n                      slug-override=\"'changelog/guestlist/' + vm.guestlist.id + '/rsvp'\"></al-entity-change-log>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/changelog.tpl.html
// module id = 2276
// module chunks = 1